import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import * as actions from 'actions'
import assets from 'modules/assets'
import ArchiveBottom from './ArchiveBottom'
import ArchiveBottom2016 from './ArchiveBottom2016'
import ArchiveBottom2017 from './ArchiveBottom2017'

class Archive extends Component {
  constructor(props) {
    super(props)
    this.state = {
      year: 2017,
      isFetching: false
    }
  }
  componentDidMount() {
    let { dispatch } = this.props,
        url = assets('archive/2017/index.md')
    dispatch(actions.token.fetchArchiveData(url))
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      archiveData: nextProps.archiveData,
      isFetching: nextProps.fetchingArchiveData
    })
  }
  changeYear = (year) => {
    let { dispatch } = this.props
    let url = assets('archive/' + year + '/index.md')
    dispatch(actions.token.fetchArchiveData(url))

    this.setState({ year: year })
  }
  render() {
    let bottom
    if (this.state.year === 2017) {
      bottom = <ArchiveBottom2017
                archiveData={this.state && this.state.archiveData}
                year={this.state.year}
                isFetching={this.state.isFetching}
              />
    } else if (this.state.year === 2016) {
      bottom = <ArchiveBottom2016
                archiveData={this.state && this.state.archiveData}
                year={this.state.year}
                isFetching={this.state.isFetching}
              />
    } else {
      bottom = <ArchiveBottom
                archiveData={this.state && this.state.archiveData}
                year={this.state.year}
              />
    }

    let dates = [2017, 2016, 2015, 2014, 2013, 2012],
        year = this.state.year,
        active = 'archive-arrow active', inactive = 'inactive'

    return (
    <section className="archive center">
      <div className="main-grid">
        <ul className="grid archive-header group">
          <div className="archive-header-left">
            <h3>Camp Archive</h3>
          </div>
          <div className="archive-header-right">
            {
              dates.map((date, i) => {
                return <h3 key={i} className={year === date ? active : inactive} onClick={this.changeYear.bind(this, date)}>{date}</h3>
              })
            }
          </div>
        </ul>
      </div>

      {bottom}
    </section>
    )
  }
}
Archive.contextTypes = {
}
Archive.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    archiveData: state.token.archiveData,
    fetchingArchiveData: state.token.fetchingArchiveData
  }
}

export default connect(mapStateToProps)(Archive)



// WEBPACK FOOTER //
// ./src/components/Archive/Archive.js